import isValidDate from "date-fns/isValid";
import { isDayjs } from "dayjs";

const parseDate = (value?: unknown): Date | undefined => {
  if (!value) {
    return undefined;
  }

  if (
    value instanceof Date ||
    typeof value === "string" ||
    typeof value === "number"
  ) {
    const dateValue = new Date(value);

    if (!isValidDate(dateValue)) {
      throw new Error(`Invalid date value: "${value}"`);
    }

    return dateValue;
  }

  if (isDayjs(value)) {
    return value.toDate();
  }

  return undefined;
};

export default parseDate;
